import { Flex, Stack } from '@chakra-ui/react';
import { Skeleton } from '@time-line/components/common';

export function ResultSkeleton() {
  return (
    <Flex
      borderBottomWidth={1}
      borderColor="blackAlpha.250"
      py="2xs"
      justifyContent="space-between"
      alignItems="center"
      _last={{
        borderBottom: 'none',
      }}
    >
      <Stack gap="2xs">
        <Skeleton
          width="80px"
          height="10px"
          borderRadius="base"
          bg="gray.200"
        />
        <Skeleton
          width="240px"
          height="24px"
          borderRadius="base"
          bg="gray.200"
        />
      </Stack>
      <Skeleton width="80px" height="80px" borderRadius="base" bg="gray.200" />
    </Flex>
  );
}
